



























































































































































import _ from 'lodash'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { UserInputFormStore, userInputStore } from '@/store/form/UserInputFormStore'
import { masterStore } from '@/store/master/MasterStoreModule'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { KeyInfo } from '@/components/common/form/types'
import { KEY_CLASS_KINMU_JIKAN_KEISAN_TYPE } from '@/tcw/constant/KeyClass'
import {
  CodeLabel,
  ApiGeneralSinglePayload,
  MShokui,
  MShozoku,
  ApiGeneralObjectArrayPayload,
  ApiPayloadValueType
} from '@/tcw/api/types'
import { IFormStore } from '@/store/types'
import ShozokuSelectDialog from '@/components/master/molecules/ShozokuSelectDialog.vue'

@Component({
  components: { ShozokuSelectDialog }
})
export default class UserInputForm extends Mixins(FormStoreComponent) {
  @Prop({ default: null })
  private userId!: number | null

  private shozokuEditIdx = -1
  private dialogOpen = false

  private shugyouKeitaiCodeList: CodeLabel[] = []
  private mShokuiList: MShokui[] | null = null
  private mShozokuList: MShozoku[] | null = null

  get formName(): string {
    return 'userInputForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return userInputStore
  }
  get userStore(): UserInputFormStore {
    return this.storeModule as UserInputFormStore
  }
  get keyInfo(): KeyInfo {
    if (this.userId && !this.isNewRecord) {
      return { userId: this.userId }
    } else {
      return {}
    }
  }
  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }
  get isNewRecord(): boolean {
    return userInputStore.isNewRecord
  }

  get shokuiOptions(): CodeLabel[] {
    if (!this.mShokuiList) {
      return []
    }
    return this.mShokuiList.map(shokui => {
      return { code: shokui.id, label: shokui.name }
    })
  }

  private async addShozoku() {
    const addIdx = await this.userStore.addShozokuRecord()
    this.shozokuEditIdx = addIdx
    this.dialogOpen = true
  }
  private openShozokuSelectDialog(idx: number): void {
    this.shozokuEditIdx = idx
    this.dialogOpen = true
  }
  private selectShozoku(shozokuId: number) {
    this.updateShozoku(this.shozokuEditIdx, 'shozokuId', shozokuId)
    this.dialogOpen = false
  }

  private deleteShozoku(index: number): void {
    this.userStore.deleteShozokuRecord(index)
  }

  private updateShozoku(index: number, property: string, value: ApiPayloadValueType) {
    this.userStore.updateShozokuRecord({ index, property, value })
  }

  private get shozokuList(): ApiGeneralObjectArrayPayload {
    const shozokuList = this.form.shozokuList as ApiGeneralObjectArrayPayload
    if (!_.isArray(shozokuList)) {
      return []
    }
    return shozokuList.map(s => {
      const mShozoku = this.mShozokuList?.find(m => m.id === s.shozokuId)
      if (mShozoku) {
        return Object.assign({}, s, mShozoku)
      } else {
        return s
      }
    })
  }

  protected async beforeProc(): Promise<void> {
    if (this.isEmptyRecord) {
      this.storeModule.clear()
    }
  }

  protected async afterProc(): Promise<void> {
    this.shugyouKeitaiCodeList = await this.codeLabel.getCodeLabelList(
      KEY_CLASS_KINMU_JIKAN_KEISAN_TYPE
    )
    this.mShozokuList = await masterStore.fetchMShozoku()
    this.mShokuiList = await masterStore.fetchMShokui()
  }
  protected async validate(): Promise<void> {
    console.log('')
  }
}
